import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const AddOnPayRatePage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'description', label: 'Description' },
    { key: 'rate', label: 'Rate' },
    { key: 'rateType', label: 'Rate Type' },
    { key: 'applicableTo', label: 'Applicable To' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'text', required: true },
    { key: 'rate', label: 'Rate ($)', type: 'text', required: true },
    { key: 'rateType', label: 'Rate Type', type: 'select', required: true, options: [
      { value: 'Flat', label: 'Flat Amount' },
      { value: 'Percentage', label: 'Percentage' },
      { value: 'Per Mile', label: 'Per Mile' },
    ]},
    { key: 'applicableTo', label: 'Applicable To', type: 'select', required: true, options: [
      { value: 'All', label: 'All Disciplines' },
      { value: 'RN', label: 'RN Only' },
      { value: 'Therapy', label: 'Therapy Only' },
      { value: 'HHA', label: 'HHA Only' },
    ]},
    { key: 'notes', label: 'Notes', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'WKEND', description: 'Weekend Differential', rate: '$15.00', rateType: 'Flat', applicableTo: 'All', active: 'Yes' },
    { id: '2', code: 'HOLIDAY', description: 'Holiday Pay', rate: '$25.00', rateType: 'Flat', applicableTo: 'All', active: 'Yes' },
    { id: '3', code: 'ONCALL', description: 'On-Call Pay', rate: '$2.00', rateType: 'Flat', applicableTo: 'All', active: 'Yes' },
    { id: '4', code: 'MILEAGE', description: 'Mileage Reimbursement', rate: '$0.67', rateType: 'Per Mile', applicableTo: 'All', active: 'Yes' },
    { id: '5', code: 'PRECP', description: 'Preceptor Pay', rate: '$10.00', rateType: 'Flat', applicableTo: 'RN', active: 'Yes' },
    { id: '6', code: 'ORIENT', description: 'Orientation/Training', rate: '$20.00', rateType: 'Flat', applicableTo: 'All', active: 'Yes' },
    { id: '7', code: 'LATE', description: 'Late Visit (After 6pm)', rate: '$10.00', rateType: 'Flat', applicableTo: 'All', active: 'Yes' },
    { id: '8', code: 'RURAL', description: 'Rural Area Bonus', rate: '$5.00', rateType: 'Flat', applicableTo: 'All', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Add-on Pay Rate"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Rate"
      formFields={formFields}
      apiEndpoint="/setup/addon-pay-rate"
    />
  );
};

export default AddOnPayRatePage;
